"use strict";

exports.__esModule = true;
exports.StripeChartBrush = void 0;
var _react = _interopRequireWildcard(require("react"));
var _luxon = require("luxon");
var _vimanaTypes = require("@vimana/vimana-types");
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Time = require("../../Time");
var _snapPointToLocation = require("./snapPointToLocation");
var _Utils = require("../../../Utils");
var _Theme = require("../../Theme");
var _StripeChartBrushHandle = require("./StripeChartBrushHandle");
var _timeDefinitions = require("../../timeDefinitions");
var _whenModern = require("../../Theme/UiDesign/whenModern");
var _dec, _class, _StripeChartBrush;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _createForOfIteratorHelperLoose(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (t) return (t = t.call(r)).next.bind(t); if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var o = 0; return function () { return o >= r.length ? { done: !0 } : { done: !1, value: r[o++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var BrushPanel = _styledComponents["default"].div.attrs(function (props) {
  return {
    style: {
      width: props.width + "px",
      height: props.height + "px"
    }
  };
}).withConfig({
  displayName: "StripeChartBrush__BrushPanel",
  componentId: "sc-coumcl-0"
})(["position:absolute;left:0px;"]);
var BrushZone = _styledComponents["default"].div.attrs(function (props) {
  return {
    style: {
      width: props.width + "px",
      height: props.height + "px",
      left: props.x + "px"
    }
  };
}).withConfig({
  displayName: "StripeChartBrush__BrushZone",
  componentId: "sc-coumcl-1"
})(["position:absolute;top:0px;", ""], (0, _whenModern.whenModern)((0, _styledComponents.css)(["border:solid 1.5px ", ";border-radius:5px;background:rgba(58,134,200,0.07);"], (0, _Theme.val)("BrushBorder")), (0, _styledComponents.css)(["border-left:solid 1px ", ";border-right:solid 1px ", ";background:rgba(186,190,191,0.5);"], (0, _Theme.val)("BrushBorder"), (0, _Theme.val)("BrushBorder"))));
var Total = _styledComponents["default"].div.attrs(function (props) {
  return {
    style: {
      left: props.width / 2 - _StripeChartBrushHandle.HANDLE_WIDTH / 2 - (props.locked ? 7 : 0) + "px",
      // 7 is the icon width /2
      top: props.height / 2 - _StripeChartBrushHandle.HANDLE_HEIGHT / 2 + "px",
      display: "" + (props.width > _StripeChartBrushHandle.HANDLE_WIDTH / 2 ? "block" : "none"),
      height: _StripeChartBrushHandle.HANDLE_HEIGHT + "px"
    }
  };
}).withConfig({
  displayName: "StripeChartBrush__Total",
  componentId: "sc-coumcl-2"
})(["background:", ";color:", ";position:absolute;width:75px;text-align:center;display:flex;", ""], (0, _Theme.val)("BrushBackgroundColor"), (0, _Theme.val)("BrushColor"), (0, _whenModern.whenModern)((0, _styledComponents.css)(["opacity:0.95;align-items:center;justify-content:center;border-radius:4px;box-shadow:0 1px 2px rgba(29,36,41,0.12);font-family:", ";font-size:11px;"], (0, _Theme.val)("ChartFontFamilyMono")), (0, _styledComponents.css)(["opacity:0.75;"])));
var WHEEL_STEP_PX = 10;
function showBrushForTheBrushingInterval(state, props, snapToMillis, scale, now) {
  // Initial case when there is no brush interval and user starts brushing
  var startMillis = state.startMillis,
    endMillis = state.endMillis;
  var brushingInterval = {
    startMillis: startMillis,
    endMillis: endMillis
  };
  var snapped = getSnappedValues(brushingInterval, props);

  // Recalculate the position of the brush as the start or end has been changed in the props
  return {
    originalSnapToMillis: snapToMillis,
    originalStartMillis: startMillis,
    originalEndMillis: endMillis,
    startMillis: snapped.startMillis,
    endMillis: snapped.endMillis,
    brushEnd: scale(snapped.endMillis === _vimanaTypes.END_OF_TIME ? now : snapped.endMillis),
    brushStart: scale(snapped.startMillis)
  };
}
var brushHandleLabelFormatter = function brushHandleLabelFormatter(millis, timezone) {
  return (0, _momentTimezone["default"])(millis).tz(timezone.name).format("hh:mm a");
};
var StripeChartBrush = exports.StripeChartBrush = (_dec = _Time.TimeContext.withContext, (0, _styledComponents.withTheme)(_class = _dec(_class = (_StripeChartBrush = /*#__PURE__*/function (_Component) {
  function StripeChartBrush() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.state = {
      // eslint-disable-next-line react/no-unused-state
      originalSnapToMillis: 1,
      // eslint-disable-next-line react/no-unused-state
      originalStartMillis: 0,
      // eslint-disable-next-line react/no-unused-state
      originalEndMillis: 0,
      startMillis: 0,
      endMillis: 0,
      brushStart: 0,
      brushEnd: 0
    };
    _this.showBrush = false;
    _this.isSlidingBrush = false;
    _this.isDraggingFreeStyle = false;
    _this.isDraggingHandle = false;
    _this.node = null;
    _this.slideStartX = -1;
    _this.dragStartX = -1;
    _this.validateBrushInterval = function () {
      var interval = _this.props.interval;
      var _this$state = _this.state,
        startMillis = _this$state.startMillis,
        endMillis = _this$state.endMillis;
      if (!startMillis || endMillis < interval.startMillis && startMillis > interval.endMillis) {
        return false;
      }
      return true;
    };
    _this.handleMovingBrushStart = function (x) {
      var _this$props = _this.props,
        locked = _this$props.locked,
        scale = _this$props.scale;
      var brushEnd = _this.state.brushEnd;

      // prevent moving below the start or above the right hand brush edge
      if (!locked && x < brushEnd && x >= 0) {
        _this.setState({
          brushStart: x,
          startMillis: Date.parse(String(scale.invert(x)))
        });
      }
    };
    _this.handleMovingBrushEnd = function (x) {
      var _this$props2 = _this.props,
        locked = _this$props2.locked,
        scale = _this$props2.scale,
        width = _this$props2.width;
      var brushStart = _this.state.brushStart;

      // prevent moving above the end or below the left hand brush edge
      if (!locked && x > brushStart && x <= width) {
        _this.setState({
          brushEnd: x,
          endMillis: Date.parse(String(scale.invert(x)))
        });
      }
    };
    _this.handleStopMovingBrush = function () {
      var _this$state2 = _this.state,
        startMillis = _this$state2.startMillis,
        endMillis = _this$state2.endMillis;
      _this.isDraggingHandle = false;

      // Apply snapping logic here so we emit the adjusted values
      var snapped = getSnappedValues({
        startMillis: startMillis,
        endMillis: endMillis
      }, _this.props);
      _this.setStateToInterval(snapped);
    };
    _this.setStateToInterval = function (interval) {
      var onBrushChange = _this.props.onBrushChange;
      _this.setState({
        startMillis: interval.startMillis,
        endMillis: interval.endMillis
      }, function () {
        if (onBrushChange) {
          onBrushChange({
            endMillis: interval.endMillis,
            startMillis: interval.startMillis
          });
        }
      });
    };
    _this.handleStartMovingBrush = function () {
      _this.isDraggingHandle = true;
    };
    _this.handleMove = function (e) {
      var enableDragging = _this.props.enableDragging;
      var _this$state3 = _this.state,
        brushStart = _this$state3.brushStart,
        brushEnd = _this$state3.brushEnd;
      if (!_this.showBrush) {
        return;
      }
      e.stopPropagation();
      var isFreeDragging = !_this.isDraggingHandle && _this.dragStartX >= 0 && _this.dragStartX !== e.clientX;
      var isSliding = !_this.isDraggingHandle && _this.slideStartX >= 0 && _this.slideStartX !== e.clientX;
      if (isFreeDragging && _this.node) {
        _this.isDraggingFreeStyle = true;
        var leftEdge = _this.node.getBoundingClientRect().x;
        var isMovingUp = e.clientX > _this.dragStartX;
        var fixedX = _this.dragStartX - leftEdge;
        var draggingX = e.clientX - leftEdge;
        if (isMovingUp) {
          // use the left brush edge as fixed point and move right
          _this.handleMovingBrushStart(fixedX);
          _this.handleMovingBrushEnd(draggingX);
        } else {
          // use the right brush edge as fixed point and move left
          _this.handleMovingBrushStart(draggingX);
          _this.handleMovingBrushEnd(fixedX);
        }
      } else if (isSliding) {
        if (enableDragging) {
          _this.isSlidingBrush = true;
          var difference = _this.slideStartX - e.clientX;
          var newbrushStart = brushStart - difference;
          var newbrushEnd = brushEnd - difference;
          if (newbrushStart >= 0 && newbrushEnd <= _this.props.width) {
            // move both end the same amount to slide it along
            _this.handleMovingBrushStart(newbrushStart);
            _this.handleMovingBrushEnd(newbrushEnd);
          }

          // we're nudged the entire position of the brush so to keep it relative we adjust our start position accordingly
          _this.slideStartX -= difference;
        }
      }
    };
    // ToDo: remove this line, it's just to test the build
    _this.handleMouseDown = function (e) {
      // only capture left click
      if (e.button !== 0) {
        return;
      }
      _this.showBrush = true;
      _this.dragStartX = e.clientX;
      e.stopPropagation();
      e.preventDefault(); // prevents the text selection on drag
    };
    _this.handleBrushDrag = function (e) {
      var enableDragging = _this.props.enableDragging;
      if (!enableDragging || e.button !== 0) {
        return;
      }
      _this.slideStartX = e.clientX;
      e.stopPropagation();
      e.preventDefault(); // prevents the text selection on drag
    };
    _this.handleClick = function (e) {
      var _this$props3 = _this.props,
        scale = _this$props3.scale,
        onClick = _this$props3.onClick,
        enableSnapToSelection = _this$props3.enableSnapToSelection,
        timeline = _this$props3.timeline;

      // only capture left click
      if (e.button !== 0) {
        return;
      }
      _this.showBrush = true;
      var target = e.target;
      var rect = target.getBoundingClientRect();
      var x = e.clientX - rect.left;
      var value = scale.invert(x);
      var point = new Date(value).valueOf();
      if (enableSnapToSelection) {
        for (var _iterator = _createForOfIteratorHelperLoose(timeline), _step; !(_step = _iterator()).done;) {
          var item = _step.value;
          var interval = item.interval;
          // is it inside timeline item
          if (point >= interval.startMillis && point <= interval.endMillis) {
            // Set it to the timeline values
            _this.setStateToInterval(interval);
          }
        }
      } else {
        // When selection is not being used, highlight a small area when clicking to give some intuitive feedback to user
        _this.setStateToInterval({
          startMillis: point - _timeDefinitions.MINUTE_IN_MILLIS,
          // -1 minute
          endMillis: point + _timeDefinitions.MINUTE_IN_MILLIS // +1 minute
        });
      }
      if (onClick) {
        onClick(point, x);
      }
    };
    _this.handleMouseUp = function (e) {
      if (_this.isDraggingFreeStyle || _this.isSlidingBrush) {
        _this.handleStopMovingBrush();
      } else if (!_this.isDraggingHandle) {
        _this.handleClick(e);
      }
      _this.isSlidingBrush = false;
      _this.isDraggingHandle = false;
      _this.isDraggingFreeStyle = false;
      _this.dragStartX = -1;
      _this.slideStartX = -1;
    };
    _this.handleMouseWheel = function (e) {
      var _this$state4 = _this.state,
        brushEnd = _this$state4.brushEnd,
        brushStart = _this$state4.brushStart;
      var width = _this.props.width;
      e.stopPropagation();
      e.preventDefault();
      var scrollUp = e.deltaY < 0;
      var brushWidth = brushEnd - brushStart;
      var newbrushStart = brushStart;
      var newbrushEnd = brushEnd;
      if (scrollUp) {
        newbrushStart = brushStart + WHEEL_STEP_PX;
        newbrushEnd = newbrushStart + brushWidth;
        var rightEdge = width - WHEEL_STEP_PX;
        if (newbrushEnd >= width) {
          return; // don't move if we're at the end
        } else if (newbrushEnd >= rightEdge) {
          // If we get to the end just set it to the end
          newbrushEnd = width;
          newbrushStart = width - brushWidth;
        }
      } else {
        newbrushStart = brushStart - WHEEL_STEP_PX;
        newbrushStart = newbrushStart <= WHEEL_STEP_PX ? 0 : newbrushStart;
        newbrushEnd = newbrushStart + brushWidth;
      }

      // move both end the same amount to slide it along
      _this.handleMovingBrushStart(newbrushStart);
      _this.handleMovingBrushEnd(newbrushEnd);
      _this.debounceBrushChange();
    };
    _this.debounceBrushChange = (0, _Utils.debounce)(function () {
      var onBrushChange = _this.props.onBrushChange;
      if (onBrushChange) {
        onBrushChange({
          endMillis: _this.state.endMillis,
          startMillis: _this.state.startMillis
        });
      }
    }, {
      delay: 100
    } // this is debounced to prevent aggressive fetching of data when wheeling or dragging
    );
    _this.handleDeselect = function () {
      var _this$props4 = _this.props,
        interval = _this$props4.interval,
        onBrushChange = _this$props4.onBrushChange;
      _this.showBrush = false;
      _this.setState({
        brushStart: interval.startMillis,
        brushEnd: interval.endMillis
      });
      if (onBrushChange) {
        onBrushChange(Object.assign({}, interval));
      }
    };
    _this.renderBrushBody = function () {
      var _this$props5 = _this.props,
        height = _this$props5.height,
        width = _this$props5.width,
        enableResize = _this$props5.enableResize,
        locked = _this$props5.locked,
        time = _this$props5.time;
      var _this$state5 = _this.state,
        currentBrushState = _this$state5.brushStart,
        currentBrushEnd = _this$state5.brushEnd,
        endMillis = _this$state5.endMillis,
        startMillis = _this$state5.startMillis;
      var hasValidBrush = _this.validateBrushInterval();

      // protect and overflowing off the left edge
      var brushStart = currentBrushState >= 0 ? currentBrushState : 0;

      // protect and overflowing off the right edge
      var brushEnd = currentBrushEnd <= width ? currentBrushEnd : width;
      var brushWidth = brushEnd - brushStart;
      var diff = endMillis - startMillis;
      var handleTop = height / 2 - _StripeChartBrushHandle.HANDLE_HEIGHT / 2;
      var panels = [];
      // Left handle
      if (enableResize && hasValidBrush) {
        panels.push(/*#__PURE__*/_react["default"].createElement(_StripeChartBrushHandle.StripeChartBrushHandle, {
          key: "brushLeft",
          isLocked: locked,
          y: handleTop,
          x: brushStart,
          onMove: _this.handleMovingBrushStart,
          onMoveFinished: _this.handleStopMovingBrush,
          onMoveStart: _this.handleStartMovingBrush,
          label: brushHandleLabelFormatter(startMillis, time.timezone)
        }));
      }
      var brushDuration = _luxon.Duration.fromMillis(diff).valueOf();
      var brushZoneLabelText = (0, _Utils.formatDuration)(brushDuration);
      // Brush overlay
      panels.push(/*#__PURE__*/_react["default"].createElement(BrushZone, {
        key: "overlay",
        title: brushZoneLabelText,
        width: brushWidth,
        height: height,
        x: brushStart,
        onMouseDown: _this.handleBrushDrag
      }, hasValidBrush && /*#__PURE__*/_react["default"].createElement(Total, {
        height: height,
        width: brushWidth,
        locked: locked
      }, /*#__PURE__*/_react["default"].createElement("span", null, brushZoneLabelText), locked ? /*#__PURE__*/_react["default"].createElement("span", {
        style: {
          margin: "0px 0 0 3px"
        },
        className: "bp6-icon bp6-icon-lock"
      }) : null)));

      // Right handle
      if (enableResize && hasValidBrush) {
        panels.push(/*#__PURE__*/_react["default"].createElement(_StripeChartBrushHandle.StripeChartBrushHandle, {
          key: "brushRight",
          isLocked: locked,
          isRightAligned: true,
          y: handleTop,
          x: brushEnd,
          onMove: _this.handleMovingBrushEnd,
          onMoveFinished: _this.handleStopMovingBrush,
          onMoveStart: _this.handleStartMovingBrush,
          label: brushHandleLabelFormatter(endMillis, time.timezone)
        }));
      }
      return panels;
    };
    return _this;
  }
  _inheritsLoose(StripeChartBrush, _Component);
  StripeChartBrush.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
    var brushInterval = props.brushInterval,
      scale = props.scale,
      width = props.width,
      snapToMillis = props.snapToMillis;
    var now = Date.now();
    if (!brushInterval && state.brushStart === 0 && state.brushEnd === width) {
      return {
        brushEnd: width,
        brushStart: 0
      };
    } else if (!brushInterval) {
      return showBrushForTheBrushingInterval(state, props, snapToMillis, scale, now);
    } else if (brushInterval.startMillis !== state.originalStartMillis || brushInterval.endMillis !== state.originalEndMillis || snapToMillis !== state.originalSnapToMillis) {
      var snapped = getSnappedValues(brushInterval, props);
      // Recalculate the position of the brush as the start or end has been changed in the props
      return {
        originalSnapToMillis: snapToMillis,
        originalStartMillis: brushInterval.startMillis,
        originalEndMillis: brushInterval.endMillis,
        startMillis: isNaN(snapped.startMillis) ? props.interval.startMillis : snapped.startMillis,
        endMillis: isNaN(snapped.endMillis) ? props.interval.startMillis + 10000 : snapped.endMillis,
        brushEnd: scale(snapped.endMillis === _vimanaTypes.END_OF_TIME ? now : snapped.endMillis),
        brushStart: scale(snapped.startMillis)
      };
    }
    return null;
  };
  var _proto = StripeChartBrush.prototype;
  _proto.render = function render() {
    var _this2 = this;
    var _this$props6 = this.props,
      height = _this$props6.height,
      width = _this$props6.width,
      enableDragging = _this$props6.enableDragging;
    return /*#__PURE__*/_react["default"].createElement(BrushPanel, {
      "data-testid": "StripeChartBrushPanel",
      ref: function ref(node) {
        _this2.node = node;
      },
      width: width,
      height: height,
      onMouseDown: this.handleMouseDown,
      onMouseUp: this.handleMouseUp,
      onMouseMove: this.handleMove,
      onDoubleClick: this.handleDeselect,
      onWheel: enableDragging ? this.handleMouseWheel : undefined
    }, this.showBrush && this.renderBrushBody());
  };
  return StripeChartBrush;
}(_react.Component), _StripeChartBrush.defaultProps = {
  theme: undefined,
  time: undefined,
  locked: true,
  snapToMillis: 1,
  timeline: [],
  enableSnapToMillis: true,
  enableSnapToTimeline: true,
  enableDragging: true,
  enableSnapToSelection: true,
  enableResize: true
}, _StripeChartBrush)) || _class) || _class);
/**
 * Given an interval calculate the snapped position and adjust the interval
 */
function getSnappedValues(interval, props) {
  var timeline = props.timeline,
    snapToMillis = props.snapToMillis,
    enableSnapToMillis = props.enableSnapToMillis,
    enableSnapToTimeline = props.enableSnapToTimeline;
  var timePoints = [];
  if (enableSnapToTimeline) {
    timePoints = timeline.reduce(function (acc, item) {
      acc.push(item.interval.startMillis);
      acc.push(item.interval.endMillis);
      return acc;
    }, []);
  }

  // Apply snapping logic
  var snappedStartMillis = (0, _snapPointToLocation.snapPointToLocation)(interval.startMillis, timePoints, enableSnapToMillis ? snapToMillis : undefined);
  var snappedEndMillis = (0, _snapPointToLocation.snapPointToLocation)(interval.endMillis, timePoints, enableSnapToMillis ? snapToMillis : undefined);
  return {
    startMillis: isNaN(snappedStartMillis) ? interval.startMillis : snappedStartMillis,
    endMillis: isNaN(snappedEndMillis) ? interval.endMillis : snappedEndMillis
  };
}